<div *ngIf="alert" class="alert alert-{{alert.type}} alert-dismissible fade show justify-self-center" role="alert">
    <span [appTruncateText]="500">
        {{ alert.message }}
    </span>
    <button type="button" class="btn-close" aria-label="Close" (click)="clearAlert()"></button>
</div>
